jQuery(document).ready(function () {
    if (window.location.href.indexOf("anmalan") > -1) {
        jQuery('input[name="drts[field_social_accounts][0][facebook]"]').attr("placeholder", "Ditt användarnamn på Facebook");

        jQuery('input[name="drts[field_social_accounts][0][instagram]"]').attr("placeholder", "Ditt användarnamn på Instagram");

        jQuery('input[name="drts[field_social_accounts][0][youtube]"]').attr("placeholder", "Ditt användarnamn på YouTube");

        jQuery('input[name="drts[field_social_accounts][0][linkedin]"]').attr("placeholder", "URL till din LinkedIn-sida");
    }



});